import styled from 'styled-components';
import { MEDIA_QUERY, SPACING } from '@optimus-web/local-tokens';
import { StackItemProps, StackProps } from './types';

const Stack = styled('div').withConfig<StackProps>({
    shouldForwardProp: (prop, defaultValidatorFn) =>
        !['fill', 'wrap', 'spacing'].includes(prop) && defaultValidatorFn(prop),
})`
    display: ${(props) => (props.inline ? 'inline-flex' : 'flex')};
    flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'nowrap')};
    justify-content: flex-start;
    margin: 0;
    padding: 0;

    & > * {
        ${(props) =>
            props.distribution === 'stretch' &&
            `
            flex-grow: 1;
            width: 100%;
        `}

        &:not(:first-child) {
            margin-left: ${(props) => (props.spacing ? SPACING[props.spacing] : 0)}px;
        }
    }

    ${(props) =>
        props.fill &&
        `
        width: 100%;
        height: 100%;
    `}

    ${(props) =>
        props.alignment === 'center' &&
        `
        justify-content: center;
    `}
    ${(props) =>
        props.alignment === 'end' &&
        `
        justify-content: flex-end;
    `}
    ${(props) =>
        props.distribution === 'space-between' &&
        `
        justify-content: space-between;
    `}

    ${(props) =>
        props.itemAlignment === 'start' &&
        `
        align-items: flex-start;
    `}
    ${(props) =>
        props.itemAlignment === 'center' &&
        `
        align-items: center;
    `}
    ${(props) =>
        props.itemAlignment === 'end' &&
        `
        align-items: flex-end;
    `}

    ${(props) =>
        props.vertical &&
        `
        ${props.vertical === true ? MEDIA_QUERY['up-to-extra-large'] : MEDIA_QUERY[props.vertical]} {
            flex-direction: column;

            && > * {
                margin-left: 0;

                &:not(:first-child) {
                    margin-top: ${props.spacing ? SPACING[props.spacing] : 0}px;
                }
            }
        }
    `}
`;

export const StackItem = styled.div<StackItemProps>`
    ${(props) => props.padding && `padding: ${SPACING[props.padding]}px;`}
    box-sizing: border-box;

    ${(props) =>
        props.contentFit &&
        `
        flex-grow: 0;
        width: auto;
    `}

    ${(props) =>
        props.width &&
        `
        min-width: ${props.width};
        flex: 0 0 ${props.width};
    `}

    ${(props) =>
        props.grow &&
        `
        flex-grow: 1;
        width: 100%;
    `}

    ${(props) => props.minWidth !== undefined && `min-width: ${props.minWidth}`}
`;

export default Stack;
